import React, { useState, useEffect } from "react";
import { toast } from "sonner";
import { useCart } from "../component/Cart/CartContext";
import { Link } from "react-router-dom";
import { FaArrowRight, FaCheckCircle } from "react-icons/fa";
import { motion } from "framer-motion";

const Checkout = () => {
  const { cart, clearCart } = useCart(); // Access the cart and clearCart from the context
  const [isSuccess, setIsSuccess] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    address: "",
    apartment: "",
    city: "",
    state: "Tunis",
    postalCode: "",
    phone: "",
    saveInfo: false,
    emailOffers: false,
  });

  useEffect(() => {
    const saved = localStorage.getItem("userCheckoutInfo");
    if (saved) {
      setFormData(JSON.parse(saved));
    }
  }, []);

  const shippingCost = 7;

  // Calculate total amount by summing up the cart items
  const totalAmount =
    (Array.isArray(cart)
      ? cart.reduce((sum, product) => sum + product.price * product.quantity, 0)
      : 0) +
    shippingCost;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const finalValue = type === "checkbox" ? checked : value;

    setFormData((prev) => {
      const updated = { ...prev, [name]: finalValue };
      // Save to local storage if saveInfo is true (or if we are checking usage)
      if (name === "saveInfo" && finalValue === true) {
        localStorage.setItem("userCheckoutInfo", JSON.stringify(updated));
      } else if (name === "saveInfo" && finalValue === false) {
        localStorage.removeItem("userCheckoutInfo");
      } else if (updated.saveInfo) {
        localStorage.setItem("userCheckoutInfo", JSON.stringify(updated));
      }
      return updated;
    });
  };

  console.log("Cart Items:", cart); // Debugging check

  if (isSuccess) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className="max-w-md w-full bg-white shadow-2xl rounded-3xl p-10 text-center border border-gray-100"
        >
          <div className="w-24 h-24 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6 text-5xl">
            <FaCheckCircle />
          </div>
          <h1 className="text-4xl font-extrabold text-gray-900 mb-4 tracking-tight">All Done!</h1>
          <p className="text-gray-500 mb-8 text-lg leading-relaxed">
            Your order has been placed successfully. We'll send you a confirmation email shortly.
          </p>
          <button
            onClick={() => window.location.href = "/"}
            className="w-full bg-black text-white py-4 rounded-2xl font-bold tracking-wide hover:bg-gray-800 transition-all shadow-lg hover:shadow-xl"
          >
            Back to Home
          </button>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="h-full pb-[80px] bg-gradient-to-br from-gray-100 via-white to-gray-200 text-gray-900 p-6 md:p-12">
      <div className="max-w-6xl  mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12">
        {/* Form Section */}
        <div className="bg-white shadow-lg rounded-2xl   p-6">
          <h1 className="text-3xl pb-6 font-bold brand">FILAMEN</h1>

          {/* Contact Info */}
          <h3 className="text-lg font-semibold poppins mb-2">Contact</h3>
          <input
            type="email"
            name="email"
            placeholder="Email or phone number"
            value={formData.email}
            onChange={handleChange}
            className="w-full px-4 py-2 focus:outline-none border rounded-lg mb-4"
          />

          <div className="mb-2">
            <label className="flex items-center text-sm text-gray-700">
              <input
                type="checkbox"
                name="emailOffers"
                checked={formData.emailOffers}
                onChange={(e) =>
                  setFormData({ ...formData, emailOffers: e.target.checked })
                }
                className="mr-2 poppins"
              />
              Email me with news and offers
            </label>
          </div>

          {/* Delivery Section */}
          <h3 className="text-lg font-semibold py-4 poppins mb-2">Delivery</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <input
              type="text"
              name="firstName"
              placeholder="First name (optional)"
              value={formData.firstName}
              onChange={handleChange}
              className="w-full px-4 py-2 focus:outline-none border rounded-lg"
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last name"
              value={formData.lastName}
              onChange={handleChange}
              className="w-full px-4 py-2 focus:outline-none border rounded-lg"
            />
          </div>
          <input
            type="text"
            name="address"
            placeholder="Address"
            value={formData.address}
            onChange={handleChange}
            className="w-full px-4 py-2 focus:outline-none border rounded-lg mb-4"
          />
          <input
            type="text"
            name="apartment"
            placeholder="Apartment, suite, etc. (optional)"
            value={formData.apartment}
            onChange={handleChange}
            className="w-full px-4 py-2 focus:outline-none border rounded-lg mb-4"
          />

          <div className="grid grid-cols-3 gap-4 mb-4">
            <input
              type="text"
              name="city"
              placeholder="City"
              value={formData.city}
              onChange={handleChange}
              className="w-full px-4 py-2 focus:outline-none border rounded-lg"
            />
            <select
              name="state"
              className="w-full px-4 py-2 border rounded-lg text-[12px] md:text-[20px] appearance-none bg-white text-gray-900"
              value={formData.state}
              onChange={handleChange}
              style={{
                backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="gray"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/></svg>')`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 1rem center",
                backgroundSize: "1.5em",
                paddingRight: "2rem",
              }}
            >
              <option value="Tunis">Tunis</option>
              <option value="Ariana">Ariana</option>
              <option value="Ben Arous">Ben Arous</option>
              <option value="Manouba">Manouba</option>
              <option value="Nabeul">Nabeul</option>
              <option value="Zaghouan">Zaghouan</option>
              <option value="Bizerte">Bizerte</option>
              <option value="Béja">Béja</option>
              <option value="Jendouba">Jendouba</option>
              <option value="Kef">Kef</option>
              <option value="Siliana">Siliana</option>
              <option value="Kairouan">Kairouan</option>
              <option value="Kasserine">Kasserine</option>
              <option value="Sidi Bouzid">Sidi Bouzid</option>
              <option value="Sousse">Sousse</option>
              <option value="Monastir">Monastir</option>
              <option value="Mahdia">Mahdia</option>
              <option value="Sfax">Sfax</option>
              <option value="Gafsa">Gafsa</option>
              <option value="Tozeur">Tozeur</option>
              <option value="Kebili">Kebili</option>
              <option value="Gabès">Gabès</option>
              <option value="Medenine">Medenine</option>
              <option value="Tataouine">Tataouine</option>
            </select>

            <input
              type="text"
              name="postalCode"
              placeholder="Postal code (optional)"
              value={formData.postalCode}
              onChange={handleChange}
              className="w-full px-4 py-2 focus:outline-none border rounded-lg"
            />
          </div>

          <input
            type="tel"
            name="phone"
            placeholder="Phone"
            value={formData.phone}
            onChange={handleChange}
            className="w-full px-4 focus:outline-none py-2 border rounded-lg mb-4"
          />
          <label className="flex items-center text-sm text-gray-700">
            <input
              type="checkbox"
              name="saveInfo"
              checked={formData.saveInfo}
              onChange={handleChange}
              className="mr-2"
            />
            Save this information for next time
          </label>
        </div>

        {/* Order Summary */}
        <div className="bg-white shadow-lg rounded-2xl p-6">
          <h2 className="text-xl font-bold border-b pb-3 mb-4 flex items-center justify-between">
            Order Summary
            <span className="bg-orange-500 text-white text-sm font-semibold px-3 py-1 rounded-full">
              {cart.length} {cart.length === 1 ? "Item" : "Items"}
            </span>
          </h2>

          <ul>
            {cart.map((item, index) => (
              <li key={`${item.id}-${index}`} className="flex justify-between mb-3">
                <div className="flex items-center gap-4">
                  <img
                    src={item.image} // Display the product image
                    alt={item.name}
                    className="w-16 h-16 object-cover rounded-lg"
                  />
                  <p>
                    {item.name}{" "}
                    <span className="text-gray-500 text-[9px]">x{item.quantity}</span>
                  </p>
                  <p className="text-[10px] text-gray-500">
                    {item.size} | {item.color}
                  </p>
                </div>
                <span className="mt-5"> {item.price * item.quantity} DT</span>
              </li>
            ))}
          </ul>

          <div className="border-t pt-4 mt-4 space-y-2">
            <p className="flex justify-between">
              <span>Shipping</span>
              <span> {shippingCost} DT</span>
            </p>


            <motion.p
              className="font-bold flex justify-between pt-4 text-lg"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.4 }}
            >
              <span>Total</span>
              <span> {totalAmount} DT</span>
            </motion.p>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="w-full mt-6 bg-black text-white py-3 rounded-lg font-semibold text-lg hover:bg-gray-800 transition"
              onClick={() => handleOrderSuccess("CASH_ON_DELIVERY")}
            >
              Confirm Order (Cash on Delivery)
            </motion.button>
          </div>
        </div>
      </div>
    </div>
  );

  async function handleOrderSuccess(reference) {
    try {
      const user = JSON.parse(localStorage.getItem("user")); // Retrieve user from storage
      const userId = user?._id || user?.id; // backend expect userId

      if (!userId) {
        toast.error("Please log in to place an order.");
        return;
      }

      // Basic validation (Matched with UI optional fields)
      const requiredFields = ["address", "city", "phone", "email", "lastName", "state"];
      const missingFields = requiredFields.filter((field) => !formData[field]);

      if (missingFields.length > 0) {
        toast.error("Please fill in all required fields.");
        return;
      }

      const orderData = {
        userId,
        addressData: {
          ...formData,
          userName: `${formData.firstName} ${formData.lastName}`,
          userEmail: formData.email,
          userPhoneNumber: formData.phone
        },
        productData: cart.map(item => ({
          productId: item.id,
          productName: item.name,
          selectedSize: item.size,
          selectedColor: item.color, // Add color
          selectedImage: item.image, // Add image
          price: item.price,
          quantity: item.quantity,
          variantId: item.variantId // Add variant ID
        })),
        paymentReference: reference // Store payment ref if needed
      };

      const API_URL = process.env.REACT_APP_API_URL || "";
      const response = await fetch(`${API_URL}/api/orders`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(orderData),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success("Order placed successfully!");
        clearCart();
        setIsSuccess(true);
      } else {
        console.error("Order creation failed:", data);
        toast.error(`Order failed: ${data.message || "Unknown error"}`);
      }
    } catch (error) {
      console.error("Error placing order:", error);
      toast.error("Something went wrong. Please contacting support.");
    }
  }
};

export default Checkout;
